import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/shared/components/ui/card";
import type { UiMiniToolItem } from "@/features/mini-tools/queries";
import { z } from "zod";
import { Link } from "react-router";

const MiniToolSettingsSchema = z.object({
  is_external: z.boolean().optional(),
});

function CardContent({ item }: { item: UiMiniToolItem }) {
  return (
    <Card className="transition-shadow hover:shadow-sm">
      <CardHeader>
        <CardTitle className="text-base">{item.name}</CardTitle>
        {item.description ? (
          <CardDescription className="line-clamp-2">
            {item.description}
          </CardDescription>
        ) : null}
      </CardHeader>
    </Card>
  );
}

type Props = {
  item: UiMiniToolItem;
};

export function MiniToolCard({ item }: Props) {
  if (!item.url) return null;

  const settingsResult = MiniToolSettingsSchema.safeParse(
    item.setting?.settings,
  );

  const isExternal = settingsResult.success
    ? (settingsResult.data.is_external ?? false)
    : false;

  return isExternal ? (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      className="block"
    >
      <CardContent item={item} />
    </a>
  ) : (
    <Link to={item.url} className="block">
      <CardContent item={item} />
    </Link>
  );
}
